import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import keycloakConfig from "../../config/keycloakConfig.json";


@Injectable({
    providedIn: 'root'
})
export class SiKeycloakConfigService {

    private config: any;
    constructor(private http: HttpClient) {}

    private getEnvironmentName(): Observable<string> {
        const env_variable = window.location.origin;
        if(env_variable.includes("uat-2"))
            return of("uat-2");
        else if(env_variable.includes("uat"))
            if(env_variable.includes("uat-eu"))
                return of("uat-eu");
            else if(env_variable.includes("uat-ca"))
                return of("uat-ca");
            else
                return of("uat");   
        else if(env_variable.includes("dev"))
            return of("dev");      
        else if(env_variable.includes("qa"))
            return of("qa");
        else if(env_variable.includes("insights"))
            if(env_variable.includes("insights-eu"))
                return of("prod-eu");
            else if(env_variable.includes("insights-ca"))
                return of("prod-ca");
            else
                return of("prod");
        return this.http.get<{ environment: string }>('si/service/auth/keycloak/env').pipe(
            switchMap(response => of(response.environment)),
            catchError(() => of('dev'))  // Fallback to default config if error occurs
        );
    }


    private loadConfigFile(envName: string): Observable<any> {
        return of(keycloakConfig[envName]);
    }

    public loadConfig(): Observable<void> {
        return this.getEnvironmentName().pipe(
            switchMap(envName => this.loadConfigFile(envName)),
            switchMap(config => { this.config = config; return of<void>(undefined); }),
            catchError(() =>  of<void>(undefined))  // Handle errors
        );
    }

    public getConfigByKey(key: string): string {
        return this.config ? this.config[key] : '';
    }
}